import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { ChatbotUserDTO } from '../models/chatbot-user-dto';


@Injectable({
  providedIn: 'root'
})

export class ChatbotUserService {

  private pathAPI = environment.urlAPI;
  private controller = "ChatbotUser/";

  public userData = new BehaviorSubject<ChatbotUserDTO | null>(null);
  
  constructor(private http: HttpClient) { }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });    
  }

  public getUserInfo(): Observable<ChatbotUserDTO> {    
    return this.http.get<ChatbotUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  public updateLastLoginDate(): Observable<any> {    
    return this.http.get<any>(this.pathAPI + this.controller + 'UpdateLastLoginDate');
  }
  
  setUserData(user: ChatbotUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<ChatbotUserDTO | null> {
    if (this.userData.value != null) {
      return of(this.userData.value);
    }
    else {
      return this.getUserInfo().pipe(map((userData: ChatbotUserDTO) => {
        this.setUserData(userData);
        return userData;
      }),
        catchError((err) => {
          return of(null);
        }));
    }
  }


}